import { useCallback, useReducer } from 'react';
import { fitZoomReducer, INITIAL_FIT_ZOOM } from '../utils/fit-zoom.js';

/**
 * Zoom state shared by SidePanel and MeetingStage. Fit is a mode, not a
 * one-shot value -- see utils/fit-zoom.ts for why.
 */
export function useFitZoom() {
  const [state, dispatch] = useReducer(fitZoomReducer, INITIAL_FIT_ZOOM);

  const reportFitZoom = useCallback(
    (fitZoom: number) => dispatch({ type: 'fitReported', fitZoom }),
    [],
  );
  const chooseZoom = useCallback((zoom: number) => dispatch({ type: 'zoomChosen', zoom }), []);
  const chooseFit = useCallback(() => dispatch({ type: 'fitChosen' }), []);
  const resetZoom = useCallback(() => dispatch({ type: 'reset' }), []);

  return { ...state, reportFitZoom, chooseZoom, chooseFit, resetZoom };
}
